import type { IconName } from '@st/ui/components/StIcon/types'
import { useUserStore } from '@st/user/stores/useUserStore'
import { useCurrenciesStore } from '@st/payments/stores/useCurrenciesStore'
import { provideQuestsDeps } from '@st/quests/useDeps'
import { useTelegram } from '@st/telegram/composables/useTelegram'
import { useWebPushStore } from '@st/pwa/stores/useWebPushStore'
import TelegramAuthButton from '@st/telegram/components/TelegramAuthButton/TelegramAuthButton.client.vue'
import { usePwaInstall } from '@st/pwa/composables/usePwaInstall'
import { useConnectTelegramMiniApp } from '../composables/useConnectTelegramMiniApp'

export default defineNuxtPlugin({
  name: 'questsDeps',
  dependsOn: ['paymentsDeps'],
  setup: () => {
    const { isTelegramMiniApp } = useTelegram()

    const userStore = useUserStore()
    const { isAuthenticated, isReady: isReadyUser } = storeToRefs(userStore)
    const { tryToAuthenticate } = userStore

    const currencyStore = useCurrenciesStore()
    const { getCurrencyByCode } = currencyStore
    const { installPwa } = usePwaInstall()

    const router = useRouter()
    const route = useRoute()

    const { handleTelegramConnect } = useConnectTelegramMiniApp()

    const webPushStore = useWebPushStore()
    const { webPushTurnOn } = webPushStore

    provideQuestsDeps({
      connectTelegramMiniApp: async () => {
        await handleTelegramConnect()
      },
      isTelegramMiniApp,
      TelegramAuthButton,
      openLogin: () => {
        router.push({ query: { ...route.query, modal: 'login' } })
      },
      tryToAuthenticate,
      isAuthenticated,
      isReadyUser,
      getCurrencyIcon: (code: string) =>
        getCurrencyByCode(code)?.icon ?? ('' as IconName),
      installPwa,
      webPushTurnOn,
    })
  },
})
